import { render, staticRenderFns } from "./CustomerBillingAddressEditDrawer.vue?vue&type=template&id=231d798f"
import script from "./CustomerBillingAddressEditDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerBillingAddressEditDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports